import thankYou from 'assets/images/campaign/thankyou.jpg';
import img35 from 'assets/images/screens/35.jpg';
import img34 from 'assets/images/screens/34.jpg';
import InfoScreens from 'views/lolly/carousel/InfoScreens';

const inviteAdmin = [
  {
    Name: "Thank you - we're working it!",
    Description: "We will send an invitation to the new admin. Once registered on Lolly, you can approve their access to your brands.",
    Image: img35,
  }
]

const addBrand = [
  {
    Name: "Thank you - we're working it!",
    Description: "We will add your brand, assign a brand adviser to check it. Once ready, you will see your new brand on Lolly, with admin rights assigned to you.",
    Image: img34,
  }
]
const AddKeyAccount = [
  {
    Name: "Your request is being checked by our team",
    Description: "Your brand adviser will add you new key account to your brand. Once confirmed, we will add the key account for you.",
    Image: thankYou,
  }
]
const AddRequest = [
  {
    Name: "Your request is being checked by our team",
    Description: "We will get back to you soon",
    Image: thankYou,
  }
]


const slidesMappings = [
  { pattern: "add-brand-admin", slides: inviteAdmin },
  { pattern: "add-brand", slides: addBrand },
  { pattern: "key-accounts/add", slides: AddKeyAccount },
];

const currentURLPath = window.location.pathname;

function getPathData(url, mappings) {
  // console.log(url)
  for (const mapping of mappings) {
    // console.log(mapping.pattern)
    if (url.includes(mapping.pattern)) {
      // console.log(mapping.pattern)
      return mapping.slides;
    }
  }
  return AddRequest;
}

const renderSlides = () => {
  const slides = getPathData(currentURLPath, slidesMappings);
  // console.log(slides)
  return (
    <>
      {slides && <InfoScreens data={slides} />}
    </>
  )
}

export default renderSlides;